import React from 'react';
import cls from 'classnames';
import styles from './index.module.scss';

export interface LoadingProps {
  loading: boolean;
  global?: boolean;
  className?: string;
  style?: React.CSSProperties;
}
function Loading(props: LoadingProps) {
  const { global = false, loading, className, style } = props;
  return (
    <div
      className={cls(
        {
          [styles.loader]: true,
          [styles.close]: !loading,
          [styles.global]: global
        },
        className
      )}
      style={style}
    >
      <div className={styles.spinner}>
        <div className={styles.cube1} />
        <div className={styles.cube2} />
      </div>
    </div>
  );
}

export default Loading;
